<template>
  <span
    class="divider"
    :class="[
      `divider--${props.size}`,
      `divider--${props.color}`,
      `divider--${props.align}`,
    ]"
    aria-hidden="true"
  ></span>
</template>
<script setup>
const props = defineProps({
  color: {
    type: String,
    validator: value => {
      return ['light', 'dark'].includes(value)
    },
    default: 'light'
  },
  size: {
    type: String,
    validator: value => {
      return ['md', 'lg'].includes(value)
    },
    default: 'md'
  },
  align: {
    type: String,
    validator: value => {
      return ['center', 'left'].includes(value)
    },
    default: 'center'
  },
})
</script>
<style scoped>
.divider {
  display: block;
  width: 4.2rem;
  height: .3rem;
  background-color: #FFF;
}
.divider--lg {
  width: 4.8rem;
  height: .5rem;
}
.divider--dark {
  background-color: var(--color-neutral-900);
}
.divider--center {
  margin: auto;
}
</style>